import { render, staticRenderFns } from "./GatherOpinion.vue?vue&type=template&id=5b1ecf9e&scoped=true"
import script from "./GatherOpinion.vue?vue&type=script&lang=js"
export * from "./GatherOpinion.vue?vue&type=script&lang=js"
import style0 from "./GatherOpinion.vue?vue&type=style&index=0&id=5b1ecf9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ecf9e",
  null
  
)

export default component.exports